var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireExtinguisher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property Detail - Pricng detail closed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3741,
    transform: "translate(-120 -1884)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fire-extinguisher (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Fire_Extinguisher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.375 0.0498047H8.625C8.94257 0.0498047 9.2002 0.307427 9.2002 0.625V2.60352L9.24023 2.6123C10.642 2.89812 11.7002 4.14022 11.7002 5.625V14.125C11.7002 15.1313 10.8813 15.9502 9.875 15.9502H7.375C6.36874 15.9502 5.5498 15.1313 5.5498 14.125V5.625C5.5498 4.14022 6.60801 2.89812 8.00977 2.6123L8.0498 2.60352V1.2002H7.375C5.62423 1.2002 4.2002 2.62426 4.2002 4.375V9.375C4.2002 10.3813 3.38126 11.2002 2.375 11.2002C2.05743 11.2002 1.7998 10.9426 1.7998 10.625C1.7998 10.3074 2.05743 10.0498 2.375 10.0498C2.74724 10.0498 3.0498 9.74724 3.0498 9.375V4.375C3.0498 1.99024 4.99024 0.0498047 7.375 0.0498047ZM6.7002 14.125C6.7002 14.4972 7.00276 14.7998 7.375 14.7998H9.875C10.2472 14.7998 10.5498 14.4972 10.5498 14.125V7.4502H6.7002V14.125ZM8.625 3.7002C7.56351 3.7002 6.7002 4.56351 6.7002 5.625V6.2998H10.5498V5.625C10.5498 4.56351 9.68649 3.7002 8.625 3.7002Z",
    fill: "#01152E",
    stroke: "white",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.125 0.0498047H13.625C13.9426 0.0498053 14.2002 0.307427 14.2002 0.625C14.2002 0.942573 13.9426 1.20019 13.625 1.2002H12.2754L12.335 1.28027L13.46 2.78027C13.6503 3.0343 13.5987 3.39448 13.3447 3.58496C13.0907 3.77535 12.7306 3.72371 12.54 3.46973L10.665 0.969727C10.5346 0.795601 10.5132 0.56284 10.6104 0.368164C10.7078 0.173354 10.9072 0.0498047 11.125 0.0498047Z",
    fill: "#01152E",
    stroke: "white",
    strokeWidth: 0.1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireExtinguisher);
export default __webpack_public_path__ + "static/media/fire-extinguisher.637bc205d0824bb086874d9c6c8675a6.svg";
export { ForwardRef as ReactComponent };